module.exports = __webpack_public_path__ + "static/water_nubian7-b0a1d550971b9a8fec04b2080b42bba8.jpg";